// src/routes/sostacRoutes.js
import { lazy } from 'react';

// Lazy load SOSTAC components for better performance
const SOSTACDashboard = lazy(() => import('../pages/sostac/SOSTACDashboard'));
const SOSTACList = lazy(() => import('../pages/sostac/SOSTACList'));
const SOSTACCreate = lazy(() => import('../pages/sostac/SOSTACCreate'));

const sostacRoutes = [
  {
    path: '/sostac',
    element: <SOSTACList />,
    meta: {
      title: 'SOSTAC Analyses',
      description: 'Strategic marketing analysis framework',
      requiresAuth: true,
      permissions: ['sostac:read']
    }
  },
  {
    path: '/sostac/new',
    element: <SOSTACCreate />,
    meta: {
      title: 'Create SOSTAC Analysis',
      description: 'Create new strategic marketing analysis',
      requiresAuth: true,
      permissions: ['sostac:create']
    }
  },
  {
    path: '/sostac/:id',
    element: <SOSTACDashboard />,
    meta: {
      title: 'SOSTAC Analysis',
      description: 'Strategic marketing analysis dashboard',
      requiresAuth: true,
      permissions: ['sostac:read']
    }
  },
  {
    path: '/brands/:brandId/sostac',
    element: <SOSTACDashboard />,
    meta: {
      title: 'Brand SOSTAC Analysis',
      description: 'Brand-specific strategic analysis',
      requiresAuth: true,
      permissions: ['sostac:read', 'brands:read']
    }
  }
];

export default sostacRoutes;